
import { PuttSituation } from "@/types/golf";

export const offensivePutts: PuttSituation = {
  id: 4,
  name: "Putts offensifs",
  image: "/lovable-uploads/a1759bdf-41e4-4336-90a4-f632cef4e0db.png?width=800",
  description: "Sur le green d'entrainement ou sur le parcours choisissez un trou et matérialisez la position de départ de 5 situations de jeu : A=3m, B=4m, C=5m, D=6m, E=7m.\nPositionner 2 balles par points A, B, C, D, E jouer successivement une balle par situation",
  distances: [
    { point: "A", distance: 3, ballCount: 3 },
    { point: "B", distance: 4, ballCount: 3 },
    { point: "C", distance: 5, ballCount: 3 },
    { point: "D", distance: 6, ballCount: 3 },
    { point: "E", distance: 7, ballCount: 3 },
  ],
  scoring: [
    { condition: "Balle rentrée", points: 2 },
    { condition: "Balle à moins de 1m", points: 1 },
    { condition: "Balle au-delà de 1m", points: 0 },
  ],
  indexTable: [
    { points: 0, index: 40 },
    { points: 1, index: 34 },
    { points: 2, index: 28 },
    { points: 3, index: 23 },
    { points: 4, index: 19 },
    { points: 5, index: 16 },
    { points: 6, index: 13 },
    { points: 7, index: 10 },
    { points: 8, index: 7 },
    { points: 9, index: 4 },
    { points: 10, index: 1 },
    { points: 11, index: -1 },
    { points: 12, index: -3 },
    { points: 13, index: -5 },
    { points: 14, index: -6 },
    { points: 15, index: -7 },
    { points: 16, index: -8 },
  ],
};
